export const TOGGLE_PREVIEW = 'TOGGLE_PREVIEW';
export const SET_PREVIEW = 'SET_PREVIEW';

export const togglePreview = () => {
    return {
        type: TOGGLE_PREVIEW
    };
};

export const setPreview = (isEnabled) => {
    return {
        type: SET_PREVIEW,
        payload: isEnabled
    };
};